<template>
  <PgButtonActionsContext class="pg-page-query-order" ref="actionsRef" :actions="actions">
    <PgButtonGroup
      v-if="topMenuPosition === 'TOP'"
      class="pg-page-query-order__button"
      :list="topButtons"
      :type="'text'"
      :round="false"
      :compileData="!compileDataIsFunction ? compileData : compileDataMrthod"
    >
      <template #right>
        <slot name="topButton"></slot>
      </template>
    </PgButtonGroup>
    <PgTopRemind
      class="pg-page-query-order__remind"
      :errors="topErrors"
      :success="topSuccess"
      :successClosable="true"
      @success-close="() => updateSuccess([])"
    ></PgTopRemind>
    <div class="pg-page-query-order__precondition" v-if="preconditionForm">
      <span class="pg-page-query-order__precondition-title">请先确定先决条件：</span>
      <PgForm
        class="pg-page-query-order__precondition-form"
        ref="preconditionRef"
        :formItems="preconditionForm"
        :model="preconditionData"
      ></PgForm>
    </div>
    <PgCriteriaForm
      class="pg-page-query-order__criteriaForm"
      ref="criteriaRef"
      v-if="queryForm?.items?.length > 0"
      @search="search"
      :formData="queryData"
      :formItems="queryForm"
      @clear="criteriaClear"
      @getCriteriaParam="updateCriteriaQueryData"
    ></PgCriteriaForm>
    <div class="pg-page-query-order__content">
      <!-- <PgResizableContainer :initialHeight="topHeight"> -->
      <PgTable
        class="pg-page-query-order__content-top"
        ref="topTableRef"
        height="100%"
        autoResize
        :style="{ height: topHeight }"
        :isIconSelection="isIconSelection"
        :isSelection="isSelection"
        :hideSelectAll="topHideSelectAll"
        :checkboxConfig="topCheckboxConfig"
        :rowShortcutNum="rowShortcutNum"
        :buttonColumnWidth="buttonColumnWidth"
        :rowButtonOnlyIcon="rowButtonOnlyIcon"
        :buttonRow="rowMenuLead"
        :showPagination="true"
        :extendCompileData="!compileDataIsFunction ? compileData : compileDataMrthod"
        v-bind="topTableProps"
        v-on="topTableEvent"
        @column-custom="columnCustom"
      >
        <template #pageLeft>
          <span class="pg-page-query-order__content-selection" v-if="isSelection"
            >已选择{{ topDataSelections.length }}项</span
          >
          <span class="pg-page-query-order__content-querytime">耗时: {{ topQueryTime }}ms</span>
        </template>
      </PgTable>
      <!-- </PgResizableContainer> -->
      <PgForm
        v-if="formConfig"
        class="pg-page-query-order__content-form"
        ref="formRef"
        :formItems="formConfig"
        :model="formData"
        :extendCompileData="!compileDataIsFunction ? compileData : compileDataMrthod"
      ></PgForm>
      <PgTable
        v-if="showBottomTable"
        class="pg-page-query-order__content-bottom"
        ref="bottomTableRef"
        height="100%"
        autoResize
        isSelection
        :rowShortcutNum="rowShortcutNum"
        :buttonColumnWidth="buttonColumnWidth"
        :rowButtonOnlyIcon="rowButtonOnlyIcon"
        :buttonRow="bottomRowMenuLead"
        :buttonTop="bottomMenuLead"
        :column="bottomColumn"
        :columnTableCode="bottomColumnTableCode"
        :columnUrl="bottomColumnUrl"
        :rowConfig="{ height: 50, ...bottomRowConfig }"
        :extendCompileData="compileDataBottom"
        @checkbox-all="bottomCheck"
        @checkbox-change="bottomCheck"
        :seachKeys="bottomSeachKeys"
        :seachPlaceholder="bottomSeachPlaceholder"
        :masterNotShowFields="masterNotShowFields"
      >
        <template #right
          ><slot name="bottomRight" :formData="formData" :bottomData="bottomData"></slot
        ></template>
      </PgTable>
    </div>
    <PgButtonGroup
      v-if="topMenuPosition === 'BOTTOM'"
      class="pg-page-query-order__button-bottom"
      :list="topButtons"
      :compileData="!compileDataIsFunction ? compileData : compileDataMrthod"
    >
      <template #left>
        <div class="pg-page-query-order__button-bottom-left"><slot name="topButton"></slot></div>
      </template>
    </PgButtonGroup>
  </PgButtonActionsContext>
</template>

<script setup>
// import { PgResizableContainer } from '../../resizable-container/index'
import { PgButtonActionsContext } from '../../button-actions-context/index'
import { PgButtonGroup } from '../../button-group/index'
import { useButtonPage, useTopErrors, useBeforValueActionsProvide } from '../../../hooks/index'
import { PgTopRemind } from '../../top-remind/index'
import { PgForm } from '../../form/index'
import { pgMessage } from '../../message/index'
import { usePrecondition } from '../hook/use-precondition'
import { PgCriteriaForm, useCriteriaQuery } from '../../criteria-form/index'
import { PgTable } from '../../table/index'
import { useTopTable } from '../hook/use-top-table'
import { useBottomTable } from '../hook/use-bottom-table'
import { computed, reactive, onMounted, onDeactivated, ref } from 'vue'
import { clone } from '../../../utils/index'

const props = defineProps({
  isIconSelection: {
    type: Boolean,
    default: true,
  },
  isSelection: Boolean,
  showBottomTable: {
    type: Boolean,
    default: true,
  },
  buttonColumnWidth: {
    type: Number,
    default: 50,
  },
  rowButtonOnlyIcon: Boolean,
  rowShortcutNum: {
    type: Number,
    default: 2,
  },
  menus: Array,
  topMenuPosition: {
    type: String,
    default: 'TOP', //TOP/BOTTOM
  },
  topMenuLead: {
    type: String,
    default: 'TOP',
  },
  rowMenuLead: {
    type: String,
    default: 'ROW',
  },
  beforActions: Object,
  //表单或表格字段数据变化后的回调
  afterCallback: Function,
  buttonActions: Object,
  extendCompileData: Object,
  //是否缓存先决条件数据
  precondCatch: Boolean,
  preconditionFormItemsUrl: {
    type: String,
    default: 'rest/ezcomp/dict/form/fetch/',
  },
  preconditionFormItems: [Array, Object],
  preconditionFormItemsCode: String,
  preconditionMessage: {
    type: String,
    default: '请完善先决条件必填信息！',
  },
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  criteriaCode: String,
  parametersStorageSuffix: String,
  // 顶部表格-code
  topColumnTableCode: String,
  // 顶部表格-列定义url
  topColumnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 顶部表格-列定义
  topColumn: [Array, Object],
  topDataUrl: String,
  topDataParam: Object,
  topPageSize: {
    type: Number,
    default: 10,
  },
  topPageSizes: Array,
  topRowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  topCheckboxConfig: Object,
  topHideSelectAll: Boolean,
  //初始是否加载上表数据
  topLoad: Boolean,
  //上表高度
  topHeight: {
    type: String,
    default: '40%',
  },
  //选中行事件
  rowChange: Function,
  formItemsUrl: {
    type: String,
    default: 'rest/ezcomp/dict/form/fetch/',
  },
  formItems: [Array, String],
  formItemsCode: String,
  formUrl: String,
  formParam: Object,
  bottomMenuLead: {
    type: String,
    default: 'BOTTOM',
  },
  bottomRowMenuLead: {
    type: String,
    default: 'BOTTOMROW',
  },
  // 底部表格-code
  bottomColumnTableCode: String,
  // 底部表格-列定义url
  bottomColumnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 底部表格-列定义
  bottomColumn: [Array, Object],
  bottomRowConfig: Object,
  bottomParentKey: String,
  bottomSeachKeys: Array,
  bottomSeachPlaceholder: String,
  //从上表添加数据到下表的钩子,接收两个参数({rows, checked})rows是本次选中或取消选中的数据数组，checked是选中或取消
  //返回对象时会同步更新中间表单的值，对象中的items更新到下表；返回数组时仅更新下表
  addItemsBefore: Function,
  masterNotShowFields: Array,
  // 模板编译数据是否使用函数， 使用函数可减少由于vue双向监听导致的很多dom重新渲染
  compileDataIsFunction: Boolean,
  transformBottomData: Function,
  // 往下表是否从开始位置添加明细（即新添加的明细从下表的顶部往下添加）
  unshift: {
    type: Boolean,
    default: false,
  },
})

const { getButtonByKey } = useButtonPage(props.menus)
const topButtons = getButtonByKey(props.topMenuLead)

const { preconditionData, preconditionForm, preconditionRef, setPreconditionData, setCatch } =
  usePrecondition({
    preconditionFormItemsUrl: props.preconditionFormItemsUrl,
    preconditionFormItems: props.preconditionFormItems,
    preconditionFormItemsCode: props.preconditionFormItemsCode,
    precondCatch: props.precondCatch,
  })

const {
  getCriteria,
  queryForm,
  queryData,
  setQueryForm,
  updateQueryData,
  setDefaultQuery,
  criteriaRef,
} = useCriteriaQuery(props.criteriaUrl, props.criteriaCode, props.parametersStorageSuffix)
const criteriaClear = () => {
  updateQueryData({})
}
const search = async (tip = true) => {
  const validateError = preconditionForm ? await preconditionRef.value?.validate?.() : null
  if (validateError) {
    if (tip) pgMessage.error(props.preconditionMessage)
    return
  }
  getTopData(true)
  setCatch()
}
// 高级查询 保存的查询条件，获取到的参数处理
const updateCriteriaQueryData = (data) => {
  updateQueryData(data)
}

const {
  bottomTableRef,
  bottomData,
  bottomCheck,
  bottomDataSelections,
  addItems,
  bottomReload,
  bottomValidate,
  validate,
  bottomRemoves,
  formConfig,
  formData,
  formRef,
  getInitFormData,
  updateFormData,
  updateBottomData,
} = useBottomTable({
  bottomParentKey: props.bottomParentKey,
  topRowConfig: props.topRowConfig,
  bottomRowConfig: props.bottomRowConfig,
  formItemsUrl: props.formItemsUrl,
  formItems: props.formItems,
  formItemsCode: props.formItemsCode,
  formUrl: props.formUrl,
  formParam: props.formParam,
  addItemsBefore: props.addItemsBefore,
  transformBottomData: props.transformBottomData,
  unshift: props.unshift,
})

const {
  topTableRef,
  topData,
  topTableEvent,
  topTableProps,
  topGetColumns,
  getTopData,
  loadTopTable,
  topQueryTime,
  seachParameters,
  setCheckbox,
  clearTop,
  reloadColumn,
  topDataSelections,
} = useTopTable({
  columnUrl: props.topColumnUrl,
  columnTableCode: props.topColumnTableCode,
  column: props.topColumn,
  dataUrl: props.topDataUrl,
  dataParam: props.topDataParam,
  pageSize: props.topPageSize,
  pageSizes: props.topPageSizes,
  criteriaCode: props.criteriaCode,
  queryData,
  bottomData,
  addItems,
  bottomParentKey: props.bottomParentKey,
  preconditionData,
  rowConfig: props.topRowConfig,
  parametersStorageSuffix: props.parametersStorageSuffix,
  rowChange: props.rowChange,
  search,
  isSelection: props.isSelection,
})

const columnCustom = async () => {
  await reloadColumn()
  search(false)
}

onMounted(async () => {
  const [[criteriaRes, defaultParameter]] = await Promise.all([getCriteria(), topGetColumns()])
  setQueryForm(criteriaRes)
  if (defaultParameter) {
    updateQueryData(defaultParameter)
  } else {
    setDefaultQuery()
  }
  if (props.topLoad) {
    getTopData(true)
  } else {
    loadTopTable({ data: [] })
  }
})

onDeactivated(() => {
  topTableRef.value?.scrollTo(0, 0)
  bottomTableRef.value?.scrollTo(0, 0)
})

// 在模板表达式中建议使用get前缀的方法，可以避免因监听导致的表格单元格等重新渲染
const compileDataMrthod = {
  getPreconditionData: () => preconditionData.value,
  getSeachParameters: () => seachParameters.value,
  getTopData: () => topData.value,
  getTopDataSelections: () => topDataSelections.value,
  getFormData: () => formData.value,
  getBottomData: () => bottomData.value,
  getBottomDataSelections: () => bottomDataSelections.value,
  ...props.extendCompileData,
  property: 'topTable',
}
const compileData = reactive({
  preconditionData,
  seachParameters,
  topData,
  topDataSelections,
  formData,
  bottomData,
  bottomDataSelections,
  ...compileDataMrthod,
})

const compileDataBottom = computed(() => {
  if (props.compileDataIsFunction) {
    return { ...compileDataMrthod, property: 'bottomTable' }
  } else {
    return { ...compileData, property: 'bottomTable' }
  }
})

//解决由于数据量大时并且滚动之后导致表格数据都被vue监听在缓存时占用空间大
// onDeactivated(() => {
//   topData.value = JSON.parse(JSON.stringify(topData.value))
//   topTableRef.value?.clearOb?.(topData.value)
//   bottomData.value = JSON.parse(JSON.stringify(bottomData.value))
//   bottomTableRef.value?.clearOb?.(bottomData.value)
// })
// onActivated(() => {
//   setCheckbox()
//   if (bottomDataSelections.value.length > 0) {
//     bottomTableRef.value?.setCheckboxRow?.(bottomDataSelections.value, true)
//   }
// })

const { topErrors, updateErrors, topSuccess, updateSuccess } = useTopErrors()

const actions = {
  ...props.buttonActions,
  updateTopErrors: ({ errors }) => updateErrors(errors),
  updateSuccess: ({ data }) => updateSuccess(data),
  updateTopSuccess: ({ data }) => {
    getTopData(true)
    bottomReload()
    updateSuccess(data)
  },
  //重新加载上表和下表数据
  reload: ({ data, errors }) => {
    if (data) {
      updateSuccess(data)
    }
    if (errors) {
      updateErrors(errors)
    }
    bottomReload()
    return Promise.all([getTopData(true), getInitFormData()])
  },
  //校验表单和下表的数据
  validate: () => {
    updateErrors([])
    return validate()
  },
  //下表校验必填
  bottomValidate: () => {
    updateErrors([])
    return bottomValidate()
  },
  //合并数据到侧滑提交
  mergeOrder: (resForm) => {
    return {
      ...resForm,
      ...preconditionData.value,
      order: {
        ...resForm?.order,
        ...preconditionData.value?.order,
      },
      items: bottomData.value,
    }
  },
  updatePreconditionData: ({ data, field }) => setPreconditionData(data, field),
  //更新下表数据
  updateBottomData: ({ data, field }) => updateBottomData(data, field),
  //更新表单数据，如果存在items也会更新下表数据
  updateFormData: ({ data }) => updateFormData(data),
  //获取表单数据
  getAllFormData() {
    const copy = Object.assign(clone(formData.value), preconditionData.value)
    if (preconditionData.value?.order && formData.value.order) {
      copy.order = Object.assign({}, formData.value.order, preconditionData.value?.order)
    }
    copy.items = bottomData.value
    return copy
  },
  getFormData() {
    return formData.value
  },
  getPreconditionData() {
    return preconditionData.value
  },
  //删除下表数据
  bottomTableRemoves({ rows }) {
    bottomRemoves(rows ?? [])
    setCheckbox()
  },
  getBottomDataSelections: () => bottomDataSelections.value,
  //重新根据下表数据更新上表选中状态
  setCheckbox,
  // 上表格选中事件
  topSelect: topTableProps.checkboxBefore,
}

// 修改字段值前的勾子
const beforActions = {
  ...props.beforActions,
}
useBeforValueActionsProvide({
  beforActions,
  formReactive: compileData,
  actions,
  afterCallback: props.afterCallback,
})

const actionsRef = ref(null)
defineExpose({
  clearTopAndBottom: () => {
    clearTop()
    bottomReload()
  },
  search,
  reload: actions.reload,
  updateBottomData: actions.updateBottomData,
  getAllFormData: actions.getAllFormData,
  getFormData: actions.getFormData,
  getPreconditionData: actions.getPreconditionData,
  getBottomData: () => bottomData.value,
  getBottomDataSelections: () => bottomDataSelections.value,
  //更新表单数据，如果存在items也会更新下表数据
  updateFormData,
  // 触发上表格选中事件
  topSelect: topTableProps.checkboxBefore,
  updateErrors,
  updateSuccess,
  setPreconditionData,
  runActions: actionsRef.value?.runActions,
  setCheckbox,
})
</script>

<style lang="scss">
@import '../style/page-query-order.scss';
</style>
